import * as types from "./types";

const appState = {
  modals: new Map()
};

export default (state = appState, action) => {
  switch (action.type) {
    case types.SHOW_MODAL: {
      const modals = new Map(state.modals);
      const { modalName, data } = action.payload;
      modals.set(modalName, data || {});
      return {
        ...state,
        modals
      };
    }
    case types.HIDE_MODAL: {
      const modals = new Map(state.modals);

      modals.set(action.payload, null);
      return {
        ...state,
        modals
      };
    }
    default:
      return state;
  }
};
